define('views/product-view',[
  'jquery',

  'connections/product-connection',

  'utils/view',
  'utils/translate',
  'utils/toast',
  'utils/local-storage',

  'modules/order-matrix',
  'modules/image-sorter',
  'modules/lonelyitem-product-addtocart',

  'rivets',
  'libs/mousetrap/mousetrap.min',

  'settings',
  'server-settings'
], function (
  $,
  ProductConnection,
  View,
  t,
  toast,
  localStorage,
  OrderMatrix,
  ImageSort,
  LonelyItem,
  rivets,
  MouseTrap,
  settings,
  serverSettings
) {
  'use strict';

  var ProductView = (function () {
    function ProductView() {
      this.container = $('#product-view');
      this.productID = this.container.data('productId');
      this.productReplaceID = this.container.data('productReplaceId');
      this.imageSort = new ImageSort();
      this.currentIndex = 0;
      this.initialColor = this.container.attr('data-initialcolor');
      this.isOutlet = $('#product-view').data('outlet') === true;

      this.flags = {
        upcomingItem: false,
        newItem: false,
        discountItem: false,
        upcomingProduct: $('#product-view').data('upcoming') === true,
        newProduct: $('#product-view').data('new') === true,
        discountProduct: $('#product-view').data('outlet') === true,
        showProductFlags: $('#product-view').data('showproductflags') === true
      };

      this.productPrice = {
        ordinary: null,
        discount: null,
        isFailedToLoadPrice: false,
        msgPriceNotAvailable: t('Price not available')
      };

      this.initProductPrice();
      this.initProductImage();
      this.initBindings();
      this.initShare();
      var that = this;
      window.addEventListener('load', function () {
        that.initCareImages();
      });
      // this.iniFavorites();

      window.ProductView = this;
    }

    ProductView.prototype.initShare = function () {
      $('.product-view__share').on('click', function (e) {
        e.stopPropagation();
        $(this).find('.product-view__share-container').addClass('active');

        $(document)
          .off('.closeShare')
          .one('click.closeShare', function () {
            $('.product-view__share-container.active').removeClass('active');
          });
      });

      // open PDF and print
      $('.product-view__share-icon.icon-print').on('click', function () {
        var pdfUrl = $('.product-view__download').attr('data-pdf-url').replace('pdf=true', 'pdf=false');
        var printWindow = window.open(
          pdfUrl,
          'Print',
          'left=200, top=200, width=950, height=500, toolbar=0, resizable=0'
        );
        printWindow.addEventListener(
          'load',
          function () {
            printWindow.print();
            printWindow.close();
          },
          true
        );
      });
    };

    ProductView.prototype.initFavourites = function () {
      // Not implemented
    };

    ProductView.prototype.initOrderMatrix = function () {
      var om = new OrderMatrix($('#order-container'));

      om.setProductData(this.productID, this.productReplaceID);
      om.init();

      $('.product-view__action-buttons__add-to-cart').on('click', function (e) {
        e.preventDefault();
        var addToCartButton = $(this);

        // REVIEW: Could refactor to handle rejects and progress notifications?
        addToCartButton.prop('disabled', true);

        om.addToCart()
          .always(function () {
            addToCartButton.prop('disabled', false);
          })
          .fail(function () {
            toast.queueError(addToCartButton.data('error'), 5000);
          });
      });

      var orderContainer = document.querySelector('#order-container');

      MouseTrap(orderContainer).bind('enter', function (e, combo) {
        e.preventDefault();
        var addToCartButton = $('.product-view__action-buttons__add-to-cart');

        addToCartButton.prop('disabled', true);
        om.addToCart().always(function () {
          addToCartButton.prop('disabled', false);
        });
      });

      MouseTrap(orderContainer).bind('right', function (e, combo) {
        e.preventDefault();
        $(e.target).closest('td').nextUntil('tr', 'td:has(input:enabled)').first().find('input').focus();
      });

      MouseTrap(orderContainer).bind('left', function (e, combo) {
        e.preventDefault();
        $(e.target).closest('td').prevUntil('tr', 'td:has(input:enabled)').first().find('input').focus();
      });

      MouseTrap(orderContainer).bind('up', function (e, combo) {
        e.preventDefault();
        var eligibleInCol = $(e.target)
          .closest('tr')
          .prevUntil('table', 'tr:has( td:eq(' + $(e.target).closest('td').index() + '):has(input:enabled))');
        eligibleInCol
          .first()
          .find('td:eq(' + $(e.target).closest('td').index() + ')')
          .find('input')
          .focus();
      });

      MouseTrap(orderContainer).bind('down', function (e, combo) {
        e.preventDefault();
        var eligibleInCol = $(e.target)
          .closest('tr')
          .nextUntil('table', 'tr:has( td:eq(' + $(e.target).closest('td').index() + '):has(input:enabled))');
        eligibleInCol
          .first()
          .find('td:eq(' + $(e.target).closest('td').index() + ')')
          .find('input')
          .focus();
      });
    };

    ProductView.prototype.initProductPrice = function () {
      var $priceEl = $('[data-container="price"]');
      if ($priceEl.children().length) return;

      ProductConnection.getProductPriceView(this.productID).then(function (priceHtml) {
        if (!priceHtml) return;

        $priceEl.html(priceHtml);
      });
    };

    // TODO
    ProductView.prototype.changeProductPriceBySKU = function (el) {
      return;
      // TODO: there is no data-sku here. Should we use a new call for article where we request erp for all skus in color
      // and show the most regular or should we take the first sku?
      // var sku = $(el).data("sku"),
      // _this = this;

      // if (sku) {
      //     CONNECTION.getArticlePrice(sku, function (price) {
      //         _this.updateProductPrice(price);
      //     });
      // }
    };

    ProductView.prototype.initProductImage = function () {
      var _this = this;
      this.imageSort.loadProductImages(this.productID, this.initialColor, function () {
        if (!Modernizr.touch) {
          /* #1803 product carousel arrows mobile bug */
          var zoomImg = $('.product-images-set__main-image .img').attr('data-src-hd');
          $('.product-images-set__main-image').zoom({
            url: zoomImg,
            touch: true
          });
        }
        _this.setRecentProduct();
      });
    };

    ProductView.prototype.loadProductImages = function (el) {
      var _this = this,
        $el = $(el),
        clickColor = $el.data('colorcode');

      this.flags.showProductFlags = false;

      if (this.parseDataAttrBoolean($el, 'upcoming')) {
        _this.flags.upcomingItem = true;
      } else {
        _this.flags.upcomingItem = false;
      }

      if (this.parseDataAttrBoolean($el, 'isnew')) {
        _this.flags.newItem = true;
      } else {
        _this.flags.newItem = false;
      }

      if (this.parseDataAttrBoolean($el, 'onsale')) {
        _this.flags.discountItem = true;
      } else {
        _this.flags.discountItem = false;
      }

      this.imageSort.loadImg(clickColor);
    };

    ProductView.prototype.parseDataAttrBoolean = function (el, attr) {
      return el.attr('data-' + attr) !== undefined && el.attr('data-' + attr).toLowerCase() === 'true';
    };

    ProductView.prototype.switchImages = function (img) {
      this.currentIndex = $('.product-images-set__thumbnails .img').index(img);
      this.imageSort.setDefinedImg(this.currentIndex);
    };

    ProductView.prototype.prevImage = function (img) {
      $('.product-images-set__main-image').trigger('zoom.destroy');
      var imgList = $('.product-images-set__thumbnails .img');
      this.currentIndex = (this.currentIndex - 1 + imgList.length) % imgList.length;
      this.imageSort.setDefinedImg(this.currentIndex);

      if (!Modernizr.touch) {
        /* #1803 product carousel arrows mobile bug */
        var zoomImg = $('.product-images-set__main-image .img').attr('data-src-hd');
        $('.product-images-set__main-image').zoom({ url: zoomImg });
      }
    };

    ProductView.prototype.nextImage = function (img) {
      $('.product-images-set__main-image').trigger('zoom.destroy');
      var imgList = $('.product-images-set__thumbnails .img');
      this.currentIndex = (this.currentIndex + 1) % imgList.length;
      this.imageSort.setDefinedImg(this.currentIndex);

      if (!Modernizr.touch) {
        /* #1803 product carousel arrows mobile bug */
        var zoomImg = $('.product-images-set__main-image .img').attr('data-src-hd');
        $('.product-images-set__main-image').zoom({ url: zoomImg });
      }
    };

    ProductView.prototype.updateLogoLink = function (el) {
      var sku = $(el).attr('data-article-id');

      if (sku !== undefined) {
        this.logoLink = serverSettings.logoLinkUrl.replace(':sku', sku);
      } else {
        this.logoLink = $(el).attr('href');
      }
    };

    ProductView.prototype.updatePdfLink = function (el) {
      var colorcode = $(el).attr('data-colorcode');

      if (colorcode !== undefined) {
        var pdfUrl = $('.product-view__download').attr('data-pdf-url');
        $('.product-view__download').attr('href', pdfUrl + '&colorcode=' + colorcode);
      }
    };

    ProductView.prototype.initCareImages = function () {
      var brokenImages = $('.icon-list>li>img').filter(':hidden');
      if (brokenImages.length) {
        var noIconList = $('<ul></ul>').addClass('bullet-list');

        brokenImages.each(function (index) {
          var text = brokenImages[index].alt;
          if (text) noIconList.append($('<li>' + text + '</li>'));
        });

        $('.product-view__careInstructions').append(noIconList);
      }
    };

    ProductView.prototype.initBindings = function () {
      var _this = this;

      this.updateLogoLink($('#placeLogoLink'));

      rivets.bind(this.container, {
        images: _this.imageSort.thatProductImageSet,
        dlImgZipUrl: settings.productImagesApiDownloadUrl
          .replace(':id', _this.productID)
          .replace(':hash', settings.hash),
        clickLoadImg: function () {
          _this.loadProductImages.call(_this, this);
          _this.changeProductPriceBySKU.call(_this, this);
          _this.updateLogoLink(this);
          _this.updatePdfLink(this);
        },
        clickBigImg: function () {
          _this.switchImages.call(_this, this);
        },
        clickVideo: function () {
          OpenmagnifyImageBox(this.dataset.videoSrc);
        },
        prevBigImg: function () {
          _this.prevImage.call(_this, this);
        },
        nextBigImg: function () {
          _this.nextImage.call(_this, this);
        },
        flags: _this.flags,
        productPrice: this.productPrice,
        view: this
      });
    };

    /**
     * Saves the product link in session storage.
     */
    ProductView.prototype.setRecentProduct = function () {
      var recentProducts = localStorage.get('recentproducts', true) || [];
      if (!$.isArray(recentProducts)) recentProducts = [];

      recentProducts.unshift(this.getProductData());

      localStorage.set('recentproducts', recentProducts, true);
    };

    /**
     * Returns link and image to save in session storage as a recently viewed product.
     * @return {Object} - product data.
     */
    ProductView.prototype.getProductData = function () {
      return {
        link: window.location.href,
        name: $('.product-view__header h1').text(),
        img: this.imageSort.thatProductImageSet.definedImg.src
      };
    };

    return ProductView;
  })();

  /*jshint newcap:false */
  return View('ProductView', function () {
    var v = new ProductView();
    var lonelyItem = new LonelyItem();
    lonelyItem.init();

    var isMatrix = $('#product-view').data('is-matrix');

    if (isMatrix === true) {
      v.initOrderMatrix();
    }
  });
});

